import api from "../api";

interface HeroBackground {
  created_at: string;
  display_order: number;
  id: number;
  image_alt: string;
  image_path: string;
  image_url: null | string;
  is_active: boolean;
  page_type: string;
  title: string;
  updated_at: string;
  updated_by: string;
}

interface HeroBackgroundResponse {
  backgrounds: HeroBackground[];
  success: boolean;
}

export async function fetchHeroBackgrounds(pageType: string) {
  const res = await api.get<HeroBackgroundResponse>(
    `/landing-page-hero-backgrounds?page_type=${pageType}`,
  );

  if (!res.data.backgrounds || res.data.backgrounds.length === 0) {
    return null;
  }

  // Get the active background with the lowest display_order
  const activeBackgrounds = res.data.backgrounds
    .filter((bg) => bg.is_active)
    .sort((a, b) => a.display_order - b.display_order);

  if (activeBackgrounds.length === 0) {
    return null;
  }

  const background = activeBackgrounds[0];

  // Construct the full image URL
  const imageUrl = background.image_path
    ? `${import.meta.env.VITE_API_STORAGE_URL}/storage/${background.image_path}`
    : background.image_url || "";

  return {
    id: background.id,
    imageAlt: background.image_alt,
    imageUrl,
    title: background.title,
  };
}
